/**
 * Petit utilitaire de feedback (son + vibration) pour les moments clés.
 * Usage : import { playCelebration } from '../utils/soundFeedback';
 *         playCelebration();
 *
 * Le son est synthétisé via Web Audio API (zéro asset, zéro octet réseau).
 */

const playArpeggio = (notes, durationMs = 600, type = 'sine') => {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const gap = 0.12;
    notes.forEach((freq, i) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = type;
      osc.frequency.value = freq;
      osc.connect(gain);
      gain.connect(ctx.destination);
      const start = ctx.currentTime + i * gap;
      gain.gain.setValueAtTime(0, start);
      gain.gain.linearRampToValueAtTime(0.25, start + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.001, start + 0.5);
      osc.start(start);
      osc.stop(start + 0.55);
    });
    setTimeout(() => { try { ctx.close(); } catch (_) { /* ignore */ } }, durationMs + 400);
  } catch (_) {
    // silent fail (autoplay policies, etc.)
  }
};

const vibrate = (pattern) => {
  try { if (navigator.vibrate) navigator.vibrate(pattern); } catch (_) { /* ignore */ }
};

// Triumph chord (Do-Mi-Sol-Do, accord majeur) : sonne « victoire / accomplissement »
export const playCelebration = () => {
  playArpeggio([523.25, 659.25, 783.99, 1046.5], 800);
  vibrate([60, 30, 60, 30, 120]);
};

// Petit « bip » de scan réussi (1 note courte)
export const playScanBeep = () => {
  playArpeggio([1046.5], 150);
  vibrate(40);
};

// Notification d'erreur (2 notes descendantes)
export const playError = () => {
  playArpeggio([440, 293.66], 350, 'square');
  vibrate([80, 40, 80]);
};

// Alerte « retard détecté » SADARayon — 3 bips fermes + vibration longue
export const playLateAlert = () => {
  playArpeggio([880, 880, 880], 600, 'square');
  vibrate([300, 100, 300, 100, 300]);
};
